import React from 'react';
import { PageShell } from '../components/pages/PageShell';
import { ContentIntro } from '../components/pages/ContentIntro';
import { ContentBody } from '../components/pages/ContentBody';
import { ContentFaq } from '../components/pages/ContentFaq';
import { RelatedPages } from '../components/pages/RelatedPages';
import { ContentCTA } from '../components/pages/ContentCTA';
import type { PageContent } from '../types/pageContent';
export function contentBreadcrumbs(page: PageContent) {
  const section = page.kind === 'service' ? {
    label: 'Services',
    path: '/10.html'
  } : page.kind === 'guide' ? {
    label: 'Resources',
    path: '/repair-guides'
  } : null;
  return [{
    label: 'Home',
    path: '/'
  }, ...(section ? [section] : []), {
    label: page.navLabel,
    path: page.path
  }];
}
export function ServiceContentPage({
  page
}: {
  page: PageContent;
}) {
  return <PageShell data-id="element-535" data-mp="2l2h1df5fgd6a"><ContentIntro page={page} breadcrumbs={contentBreadcrumbs(page)} data-id="element-536" data-mp="2l0o06fdl2l5o" /><ContentBody page={page} data-id="element-537" data-mp="2q0it0ogx5ktd" />
    <ContentFaq faqs={page.faqs || []} data-id="element-538" data-mp="2pzqw9abl5h1i" /><RelatedPages links={page.related || []} data-id="element-539" data-mp="3a6utdstcxp7n" /><ContentCTA data-id="element-540" data-mp="3a5tl1w3q7gtm" /></PageShell>;
}